import { render, staticRenderFns } from "./ExpoChapterQuestionEntity.vue?vue&type=template&id=1f41ef7a&scoped=true"
import script from "./ExpoChapterQuestionEntity.vue?vue&type=script&lang=js"
export * from "./ExpoChapterQuestionEntity.vue?vue&type=script&lang=js"
import style0 from "./ExpoChapterQuestionEntity.vue?vue&type=style&index=0&id=1f41ef7a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f41ef7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f41ef7a')) {
      api.createRecord('1f41ef7a', component.options)
    } else {
      api.reload('1f41ef7a', component.options)
    }
    module.hot.accept("./ExpoChapterQuestionEntity.vue?vue&type=template&id=1f41ef7a&scoped=true", function () {
      api.rerender('1f41ef7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ExpoChapterQuestionEntity.vue"
export default component.exports